import React, { useState, useEffect , useRef } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import { PickUpdateError } from "../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dayjs } from "../../../utils/Date/DateUtil";

const PickUpTime: React.FC<any> = (props: any) => {
  const { 
    fromDate, 
    toDate, 
    pickUpLocalTime, 
    handleError, 
    errorMessage = PickUpdateError,
    errorMessage2,
    rangeDisable = false 
  } = props;
  const [showError, setShowError] = useState(false);
  const fromDatepickerRef = useRef(null);
  const toDatepickerRef = useRef(null);
  const handleChange = (event: any) => {
    props.handleChange(event);
  };
  function handleClickDatepickerIcon(ref: any) {
    const datepickerElement: any = ref.current;
    datepickerElement.setOpen(true);
  }

  useEffect(() => {
    if (props.rangeDisable && showError) {
      setShowError(false);
      handleError(false);
    } else {
      if (fromDate && toDate) {
        const value = toDate.split("T")[0] < fromDate.split("T")[0];
        setShowError(value || props.error);
        handleError(value);
      }
    }
  }, [fromDate, toDate,props.error, rangeDisable]);
  
  const getRightDateIgnoreTimeZone = (pickTime: any) => {
    const dateString = pickTime?.split("T")[0]?.replace(/-/g, "/");
    return new Date(dateString);
  };

  return (
    <>
      <IonGrid className="pickup-time-grid">
        <IonRow className="pickup-time-row">
          <IonCol size="6" className="pickup-time-col from-date-col">
            <div className={`date-pick ${rangeDisable ? 'date-disabled' : ''}`} data-testid="pickUpDateTime" >
              <DatePicker
                showPopperArrow={false}
                placeholderText=""
                onChange={(e: Date) => {
                  const event = {
                    target: {
                      name: "fromDate",
                      value: e === null ? dayjs(fromDate).format().toString() : dayjs(e).format().toString(),
                    },
                  };
                  handleChange(event);
                }}
                selected={fromDate && getRightDateIgnoreTimeZone(fromDate)}
                disabled={rangeDisable}
                dateFormat="MMM d, yyyy"
                className="custom-class"
                minDate={pickUpLocalTime && getRightDateIgnoreTimeZone(pickUpLocalTime)}
                ref={fromDatepickerRef}
              />
              <IonIcon src="assets/icon/calender.svg" className="date-icon" data-testid="fromDateCalendarIcon" onClick={() => handleClickDatepickerIcon(fromDatepickerRef)}/>
            </div>
          </IonCol>
          <IonCol size="6" className="pickup-time-col to-date-col">
            <div className={`date-pick ${rangeDisable ? 'date-disabled' : ''}`} data-testid="pickUpToDateTime">
              <DatePicker
                showPopperArrow={false}
                placeholderText=""
                onChange={(e: Date) => {
                  const event = {
                    target: {
                      name: "toDate",
                      value: e === null ? dayjs(toDate).format().toString() : dayjs(e).format().toString(),
                    },
                  };
                  handleChange(event);
                }}
                selected={toDate && getRightDateIgnoreTimeZone(toDate)}
                disabled={rangeDisable}
                dateFormat="MMM d, yyyy"
                className="custom-class"
                minDate={pickUpLocalTime && getRightDateIgnoreTimeZone(pickUpLocalTime)}
                ref={toDatepickerRef}
              />
              <IonIcon src="assets/icon/calender.svg" className="date-icon"  onClick={() => handleClickDatepickerIcon(toDatepickerRef)}/>
            </div>
          </IonCol>
        </IonRow>
        {showError ? (
        <IonRow className="pickupdate-error">
          <IonCol>
          {errorMessage && <p>{errorMessage}</p>}
          {errorMessage2 && <p>{errorMessage2}</p>}
          </IonCol>
        </IonRow>
      ) : null}
      </IonGrid>
    </>
  );
};

export default React.memo(PickUpTime);
